import React, { PureComponent } from 'react'
import cls from 'classnames'
import styles from './style.module.less'

export default class extends PureComponent {
  static defaultProps = {
    showTotal: false,
    required: false
  }
  render() {
    const { maxLeng, showTotal, after, value } = this.props
    const len = String(value || '').length

    return (
      <div
        className={cls({
          [styles.input]: true,
          [styles.required]: this.props.required
        })}
      >
        {this.props.children}
        {maxLeng !== undefined &&
          showTotal && (
            <span className={styles.total_text_right}>
              <span style={{ color: len > maxLeng ? '#f50' : '#666' }}>
                {len}
              </span>/{maxLeng}
            </span>
          )}
        {after && <span className={styles.total_text_right}>{after}</span>}
      </div>
    )
  }
}
